import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppComponent} from './app.component';
import { StoreModule } from '@ngrx/store';
import {MDBSpinningPreloader,  ToastModule, MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {AgmCoreModule} from '@agm/core';
import { HttpClientModule, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { JwtModule } from "@auth0/angular-jwt";
import { AppRoutingModule } from './app-routing.module';
import { TokenInterceptor } from './admin/interceptor/token.interceptor';
 import { environment } from 'src/environments/environment';



@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        StoreModule.forRoot({}),
        MDBBootstrapModulesPro.forRoot(),
        ToastModule.forRoot(),
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'your key here'
        }),
        JwtModule.forRoot({
            config: {
              allowedDomains: [environment.baseUrl],
            },
          })
      
    ],
    providers: [
      MDBSpinningPreloader,  {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
      } ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule  {
  
}
